import { useState } from "react"

import PageHeader from "../components/PageHeader"
import TextInput from "../components/TextInput"
import Button from "../components/Button"
import Spinner from "../components/Spinner"
import ModelSelect from "../components/ModelSelect"
import TextResult from "../components/TextResult"
import ErrorResult from "../components/ErrorResult"

import {
  classificationConfig,
  CLASSIFICATION_MODELS
} from "../config/classification"

import { type ClassificationRequest, type ClassificationResponse } from "../types/classification"

import { callAPI } from "../lib/api"
import type { APIError } from "../types/api"

export default function ClassifyPage() {
  const [config, setConfig] = useState<ClassificationRequest>({
    task: "classify",
    text: "",
    model: "mlp",
  })
  const [loading, setLoading] = useState<boolean>(false)
  const [result, setResult] = useState<ClassificationResponse | APIError | null>(null)

  const handleRun = async () => {
    if (loading) return

    if (!config.text.trim()) {
      setResult({
        error: "Please enter some text."
      })
      return
    }

    if (
      config.text.trim().split(/\s+/).length <
      classificationConfig.input_text_min_length
    ) {
      setResult({
        error: `Please enter at least ${classificationConfig.input_text_min_length} words`
      })
      return
    }

    setLoading(true)
    setResult(null)

    try {
      const data = await callAPI<ClassificationRequest, ClassificationResponse>(
        classificationConfig.endpoint,
        config
      )

      setResult(data)
    } catch (err: any) {
      setResult({
        error: err.message
      })
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className="max-w-4xl mx-auto p-6">
      <PageHeader
        title={classificationConfig.title}
      />

      <TextInput
        label="Input Text"
        value={config.text}
        onChange={(value) =>
          setConfig((prev) => ({ ...prev, text: value }))
        }
      />

      <ModelSelect
        models={CLASSIFICATION_MODELS}
        value={config.model}
        onChange={(value) =>
          setConfig((prev) => ({ ...prev, model: value }))
        }
      />

      <Button
        label="Predict"
        onClick={handleRun}
        loading={loading}
      />

      {loading && <Spinner />}

      <div className="mt-6">
        {result === null ? null : "error" in result ? (
          <ErrorResult message={result.error} />
        ) : (
          <TextResult result={result} />
        )}
      </div>

      <img
        src="./bg.jpg"
        className="object-cover fixed top-0 left-0 w-screen h-screen -z-10 sm:object-fill"
        alt="background"
      />

    </div>
  )
}